import session from "../../../services/session";
import swal from "sweetalert2";
import AdminApi from "../../../services/api";

const AdminApiService = new AdminApi()

export default {
    data() {
        return {
            id: 0,
            expireDate: null,
            restOfTraining: '',
            model: {
                email: '',
                name: '',
                phone: '',
                surname: '',
                username: '',
                role: null
            }
        }
    },
    methods: {
        load:load,
        update:update,
        resetPassword: resetPassword,
        formatDate:formatDate
    },
    beforeMount() {
        if(session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN' && session.getRole() !== 'ROLE_USER') {
            this.$router.push('/home');
            return;
        }
        this.load()
    }
}

function load() {
    let _self = this;
    AdminApiService.getProfile()
        .then((response) => {
            _self.model = response.data;
            _self.expireDate = response.data.expireDate;
            if(response.data.restOfTraining > 50){
                _self.model.restOfTraining = '∞'
            }else {
                _self.model.restOfTraining = '' + response.data.restOfTraining
            }

        })
        .catch(error => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function update() {
    let _self = this;
    AdminApiService.updateProfile(_self.model)
        .then((response) => {
            swal('Uspešno', 'Uspešno izmenjeni podaci.', 'success')
        })
        .catch(error => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function resetPassword() {
    this.$router.push('/reset-password');
}

function formatDate(date) {
    return this.$moment(new Date(date * 1000)).format('DD-MM-YYYY')
}


// WEBPACK FOOTER //
// ./src/components/Users/Profile/Profile.js